import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigation } from 'react-router';

import { useIsMobile } from '~/core/hooks/useMediaQuery';
import { useLayoutStore } from '~/shared/stores/layoutStore';

export function GlobalLoadingScreen() {
  const navigation = useNavigation();
  const location = useLocation();
  const isPendingNavigation = useLayoutStore((state) => state.isPendingNavigation);
  const [shouldRender, setShouldRender] = useState(true);
  const [opacity, setOpacity] = useState(1);
  const { t } = useTranslation(['common']);

  const isRouteChanging =
    navigation.state !== 'idle' &&
    navigation.location &&
    navigation.location.pathname !== location.pathname;

  const isInitialLoad = !location.key || location.key === 'default';
  const isActive = isInitialLoad || isPendingNavigation || isRouteChanging;
  const showFullLoader = isInitialLoad || isPendingNavigation || isRouteChanging;

  const isSidebarOpen = useLayoutStore((state) => state.isSidebarOpen);
  const isMobile = useIsMobile();

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (isActive) {
      setShouldRender(true);
      setOpacity(1);
    } else {
      setOpacity(0);
      timeout = setTimeout(() => setShouldRender(false), 200);
    }

    return () => clearTimeout(timeout);
  }, [isActive]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-200 ease-in-out ${isActive ? '' : 'pointer-events-none'}`}
      style={{
        opacity,
        backgroundColor: '#f3f4f4',
        top: '80px', // Below the TopBar (h-20)
        left: isSidebarOpen && !isMobile ? '320px' : isMobile ? '0' : '96px',
      }}
    >
      {/* Only show spinner + text for initial load or SecureLink pending */}
      {showFullLoader && (
        <div className="relative flex flex-col items-center space-y-8">
          <div className="logo-pulse mb-2">
            <div className="windows-loader">
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
          <div className="text-center">
            <p className="bodyLg font-semibold tracking-wide text-primarySemiDark">
              {t('loadingContent')}
            </p>
            <p className="bodySm text-primarySemiDark/60 mt-1">{t('loadingContentDescription')}</p>
          </div>
        </div>
      )}
    </div>
  );
}
